<template>
<div>
  <p>Click to enable Klarna payment option. This will <b>only</b> be used for this session, refreshing the page will remove Klarna from payment methods. The Klarna integration is currently only connected with <b>the Klarna Playground (test) API</b>. No transactions will actually be performed.</p>
  <p>You will be redirected to the homepage after clicking the button below so you can test the whole purchase flow.</p>

  <br><br>

  <el-button
    @click="testKlarna()"
    >
    Enable Klarna at checkout (only for this session)
  </el-button>
</div>
</template>

<script>
export default {
  methods: {
    testKlarna () {
      this.$store.commit('showKlarnaPaymentOption', true)
      this.$router.push({ name: 'HomePage' })
    }
  }
}
</script>
